import { normalizeShift } from '@/modules/shift-and-reports/utils/shiftNormalizer'

export default {
    SET_WORK_SHIFTS(state, { items, append }) {
        state.workShifts = append ? [...state.workShifts, ...items] : items
    },

    SET_WORK_SHIFTS_TOTAL(state, total) {
        state.workShiftsTotal = total
    },

    SET_REPORTS(state, val) {
        state.reports = val
    },

    SET_CURRENT_SHIFT(state, rawShift) {
        state.currentShift = normalizeShift(rawShift)
    },

    SET_CURRENT_DIVISION(state, val) {
        state.currentDivision = { ...val }
    },

    SET_SHIFT_PROCESSING(state, val) {
        state.shiftProcessing = Boolean(val)
    },

    SET_IS_SHIFT_LOADED(state, val) {
        state.isShiftLoaded = Boolean(val)
    },

    SET_IS_R_KEEPER_HAS_ERROR(state, val) {
        state.isRKeeperHasError = Boolean(val)
    },

    SET_R_KEEPER_ERROR_TEXT(state, val) {
        state.rKeeperErrorText = val
    },
    SET_COURIERS(state, val) {
        state.couriers = val
    },
}
